export default __webpack_public_path__ + "static/media/performance.f64210dc.png";